import type { IAttributes, IDirective, INgModelController } from "angular";
import type { Moment } from "moment-timezone";
import { tz } from "moment-timezone";

export default class BaseDateDirectiveFunctions implements IDirective {
    public static link(validatorName: string, validateFn: (d1: Moment, d2: Moment, inclusive: boolean) => boolean) {
        return (scope: any, el: JQuery, attributes: IAttributes, ctrl: INgModelController) => {
            ctrl.$validators[validatorName] = (modelValue: string) => {
                const otherDate: Moment = scope[validatorName];

                if (ctrl.$isEmpty(otherDate) || ctrl.$isEmpty(modelValue)) {
                    return true;
                }

                const { inclusive } = scope;
                const timeZone = scope.timeZone || tz.guess();
                const thisDate: Moment = tz(modelValue, `${scope.dateFormat} h:mm A`, timeZone);

                if (!thisDate.isValid()) {
                    return true;
                }

                return validateFn(thisDate, otherDate, inclusive);
            };

            scope.$watch(validatorName, () => {
                ctrl.$validate();
            });
        };
    }
}
